import React, { createContext, useContext } from "react";
import { Link } from "react-router-dom";
import { SIGNUP_PATH } from "../account/accountRules";
import useCurrentUser from "../account/useCurrentUser";

// The three ways in to trackmystreet, as the landing page labels them: open to
// everyone, a free account (the map, a home's page), or a subscription (reports and AI)
export const TIERS = {
    open:{className:'t-open', text:'Free · no sign-up', short:'Free'},
    account:{className:'t-acct', text:'Free account', short:'Free account'},
    sub:{className:'t-sub', text:'Subscription', short:'Subscription'},
    // A single report on one home, bought once
    once:{className:'t-sub', text:'One-off purchase', short:'One-off'},
};

// What the user already has, as {account, sub}, provided by the landing page: a pill with
// hideOwned isn't shown for a tier they have (no "Free account" for someone logged in)
export const OwnedTiersContext = createContext(null);

const ICONS = {
    open:<><circle cx="6" cy="6" r="4.6" fill="none" stroke="currentColor" strokeWidth="1.4"/>
        <path d="M1.4 6h9.2M6 1.4c1.6 1.6 1.6 7.6 0 9.2M6 1.4c-1.6 1.6-1.6 7.6 0 9.2" fill="none" stroke="currentColor" strokeWidth="1.1"/></>,
    account:<><circle cx="6" cy="4" r="2.4" fill="none" stroke="currentColor" strokeWidth="1.4"/>
        <path d="M1.8 11c.6-2.3 2.2-3.4 4.2-3.4s3.6 1.1 4.2 3.4" fill="none" stroke="currentColor" strokeWidth="1.4"/></>,
    once:<path d="M6 1l1.5 3.2L11 4.6 8.4 7l.7 3.5L6 8.8 2.9 10.5 3.6 7 1 4.6l3.5-.4z" fill="currentColor"/>,
    sub:<path d="M6 1l1.5 3.2L11 4.6 8.4 7l.7 3.5L6 8.8 2.9 10.5 3.6 7 1 4.6l3.5-.4z" fill="currentColor"/>,
};

// The tier's pill; short for the tight spots, icon to lead with its symbol. For someone
// not logged in, the free account and subscription pills link to sign up, unless plain
// (a pill inside another link).
const Tier = ({tier, short=false, icon=false, plain=false, hideOwned=false}) => {
    const user = useCurrentUser();
    const owned = useContext(OwnedTiersContext);
    if (hideOwned && owned && owned[tier]) return null;
    const content = <>
        {icon && <svg viewBox="0 0 12 12" aria-hidden="true">{ICONS[tier]}</svg>}
        {short ? TIERS[tier].short : TIERS[tier].text}
    </>;
    const className = 'tier '+TIERS[tier].className;
    if (!plain && tier!=='open' && user && !user.signedin) {
        return <Link className={className+' join'} to={SIGNUP_PATH} title="Sign up free">{content}</Link>;
    }
    return <span className={className}>{content}</span>;
};

export default Tier;
